export const serverbaselink = 'https://medgo.herokuapp.com';
// export const serverbaselink = 'http://localhost:8000';
// export const serverbaselink = 'http://192.168.1.100:8001';

// export const socketlink = 'http://localhost:4000';
export const socketlink = '';
